import {
  Badge,
  Button,
  Center,
  Container,
  Flex,
  Heading,
  Image,
  Link,
  SimpleGrid,
  Stack,
  Text,
  useColorModeValue,
} from '@chakra-ui/react';
import React from 'react';
import Project01 from '../assets/Project01.png';

const Projects = () => {
  return (
    <Container maxW={'10xl'} py={16} id="projects">
      <Stack spacing={4}>
        <Text
          textTransform={'uppercase'}
          color={'blue.400'}
          fontWeight={600}
          fontSize={'sm'}
          bg={useColorModeValue('blue.50', 'blue.900')}
          p={2}
          alignSelf={'flex-start'}
          rounded={'md'}
        >
          Projects
        </Text>
      </Stack>

      <SimpleGrid columns={{ base: 1, lg: 2, md: 1, sm: 1 }}>
        <Center py={6} mx={4}>
          <Stack
            borderWidth="1px"
            borderRadius="lg"
            w={{ sm: '100%', md: '540px' }}
            height={{ sm: '476px', md: '20rem' }}
            direction={{ base: 'column', md: 'row' }}
            bg={useColorModeValue('white', 'gray.900')}
            boxShadow={'2xl'}
            padding={4}
          >
            <Flex flex={1} bg="blue.200">
              <Image
                objectFit="cover"
                boxSize="100%"
                src={`${'https://i.imgur.com/VZkMo6P.png'}`}
              />
            </Flex>
            <Stack
              flex={1}
              flexDirection="column"
              justifyContent="center"
              alignItems="center"
              p={1}
              pt={2}
            >
              <Heading fontSize={'2xl'} fontFamily={'body'}>
                purplle
              </Heading>
              <Text fontWeight={600} color={'gray.500'} size="sm" mb={4}>
                @cloned_project
              </Text>
              <Text
                textAlign={'center'}
                color={useColorModeValue('gray.700', 'gray.400')}
                px={3}
              >
                Purplle is a one stop solution for all your favourite beauty
                products, also able to buy at your finger tips.
              </Text>
              <Stack
                align={'center'}
                justify={'center'}
                direction={'row'}
                mt={6}
              >
                <Badge
                  px={2}
                  py={1}
                  bg={useColorModeValue('gray.50', 'gray.800')}
                  fontWeight={'400'}
                >
                  #ReactJs
                </Badge>
                <Badge
                  px={2}
                  py={1}
                  bg={useColorModeValue('gray.50', 'gray.800')}
                  fontWeight={'400'}
                >
                  #Chakra-UI
                </Badge>
                <Badge
                  px={2}
                  py={1}
                  bg={useColorModeValue('gray.50', 'gray.800')}
                  fontWeight={'400'}
                >
                  #MongoDB
                </Badge>
              </Stack>

              <Stack
                width={'100%'}
                mt={'2rem'}
                direction={'row'}
                padding={2}
                justifyContent={'space-between'}
                alignItems={'center'}
              >
                <Link
                  href="https://snazzy-cranachan-14966f.netlify.app/"
                  isExternal
                >
                  <Button
                    px={10}
                    flex={1}
                    fontSize={'sm'}
                    rounded={'full'}
                    _focus={{
                      bg: 'gray.200',
                    }}
                    _hover={{
                      color: 'red',
                    }}
                  >
                    Live!
                  </Button>
                </Link>
                <Link
                  href={'https://github.com/rishunayak/purplle'}
                  target={'_blank'}
                >
                  <Button
                    flex={1}
                    fontSize={'sm'}
                    rounded={'full'}
                    bg={'blue.400'}
                    color={'white'}
                    boxShadow={
                      '0px 1px 25px -5px rgb(66 153 225 / 48%), 0 10px 10px -5px rgb(66 153 225 / 43%)'
                    }
                    _hover={{
                      bg: 'blue.500',
                    }}
                    _focus={{
                      bg: 'blue.500',
                    }}
                  >
                    Source Code
                  </Button>
                </Link>
              </Stack>
            </Stack>
          </Stack>
        </Center>
        <Center py={6} mx={4}>
          <Stack
            borderWidth="1px"
            borderRadius="lg"
            w={{ sm: '100%', md: '540px' }}
            height={{ sm: '476px', md: '20rem' }}
            direction={{ base: 'column', md: 'row' }}
            bg={useColorModeValue('white', 'gray.900')}
            boxShadow={'2xl'}
            padding={4}
          >
            <Flex flex={1} bg="blue.200">
              <Image objectFit="cover" boxSize="100%" src={`${Project01}`} />
            </Flex>
            <Stack
              flex={1}
              flexDirection="column"
              justifyContent="center"
              alignItems="center"
              p={1}
              pt={2}
            >
              <Heading fontSize={'2xl'} fontFamily={'body'}>
                Fitness Blender
              </Heading>
              <Text fontWeight={600} color={'gray.500'} size="sm" mb={4}>
                @cloned_project
              </Text>
              <Text
                textAlign={'center'}
                color={useColorModeValue('gray.700', 'gray.400')}
                px={3}
              >
                This a clone project of very popular websites among fitness
                enthusiasts which helps user to fit & healthy.
              </Text>
              <Stack
                align={'center'}
                justify={'center'}
                direction={'row'}
                mt={6}
              >
                <Badge
                  px={2}
                  py={1}
                  bg={useColorModeValue('gray.50', 'gray.800')}
                  fontWeight={'400'}
                >
                  #HTML5
                </Badge>
                <Badge
                  px={2}
                  py={1}
                  bg={useColorModeValue('gray.50', 'gray.800')}
                  fontWeight={'400'}
                >
                  #CSS3
                </Badge>
                <Badge
                  px={2}
                  py={1}
                  bg={useColorModeValue('gray.50', 'gray.800')}
                  fontWeight={'400'}
                >
                  #Javascript
                </Badge>
              </Stack>

              <Stack
                width={'100%'}
                mt={'2rem'}
                direction={'row'}
                padding={2}
                justifyContent={'space-between'}
                alignItems={'center'}
              >
                <Button
                  flex={1}
                  fontSize={'sm'}
                  rounded={'full'}
                  _focus={{
                    bg: 'gray.200',
                  }}
                >
                  Live!
                </Button>
                <Link
                  href={'https://github.com/sanjayrathva091/fitnessBlender'}
                  target={'_blank'}
                >
                  <Button
                    flex={1}
                    fontSize={'sm'}
                    rounded={'full'}
                    bg={'blue.400'}
                    color={'white'}
                    boxShadow={
                      '0px 1px 25px -5px rgb(66 153 225 / 48%), 0 10px 10px -5px rgb(66 153 225 / 43%)'
                    }
                    _hover={{
                      bg: 'blue.500',
                    }}
                    _focus={{
                      bg: 'blue.500',
                    }}
                  >
                    Source Code
                  </Button>
                </Link>
              </Stack>
            </Stack>
          </Stack>
        </Center>
        <Center py={6} mx={4}>
          <Stack
            borderWidth="1px"
            borderRadius="lg"
            w={{ sm: '100%', md: '540px' }}
            height={{ sm: '476px', md: '20rem' }}
            direction={{ base: 'column', md: 'row' }}
            bg={useColorModeValue('white', 'gray.900')}
            boxShadow={'2xl'}
            padding={4}
          >
            <Flex flex={1} bg="blue.200">
              <Image objectFit="cover" boxSize="100%" src={`${Project01}`} />
            </Flex>
            <Stack
              flex={1}
              flexDirection="column"
              justifyContent="center"
              alignItems="center"
              p={1}
              pt={2}
            >
              <Heading fontSize={'2xl'} fontFamily={'body'}>
                Fitness Blender
              </Heading>
              <Text fontWeight={600} color={'gray.500'} size="sm" mb={4}>
                @cloned_project
              </Text>
              <Text
                textAlign={'center'}
                color={useColorModeValue('gray.700', 'gray.400')}
                px={3}
              >
                This a clone project of very popular websites among fitness
                enthusiasts which helps user to fit & healthy.
              </Text>
              <Stack
                align={'center'}
                justify={'center'}
                direction={'row'}
                mt={6}
              >
                <Badge
                  px={2}
                  py={1}
                  bg={useColorModeValue('gray.50', 'gray.800')}
                  fontWeight={'400'}
                >
                  #HTML5
                </Badge>
                <Badge
                  px={2}
                  py={1}
                  bg={useColorModeValue('gray.50', 'gray.800')}
                  fontWeight={'400'}
                >
                  #CSS3
                </Badge>
                <Badge
                  px={2}
                  py={1}
                  bg={useColorModeValue('gray.50', 'gray.800')}
                  fontWeight={'400'}
                >
                  #Javascript
                </Badge>
              </Stack>

              <Stack
                width={'100%'}
                mt={'2rem'}
                direction={'row'}
                padding={2}
                justifyContent={'space-between'}
                alignItems={'center'}
              >
                <Button
                  flex={1}
                  fontSize={'sm'}
                  rounded={'full'}
                  _focus={{
                    bg: 'gray.200',
                  }}
                >
                  Live!
                </Button>
                <Link
                  href={'https://github.com/sanjayrathva091/fitnessBlender'}
                  target={'_blank'}
                >
                  <Button
                    flex={1}
                    fontSize={'sm'}
                    rounded={'full'}
                    bg={'blue.400'}
                    color={'white'}
                    boxShadow={
                      '0px 1px 25px -5px rgb(66 153 225 / 48%), 0 10px 10px -5px rgb(66 153 225 / 43%)'
                    }
                    _hover={{
                      bg: 'blue.500',
                    }}
                    _focus={{
                      bg: 'blue.500',
                    }}
                  >
                    Source Code
                  </Button>
                </Link>
              </Stack>
            </Stack>
          </Stack>
        </Center>
        <Center py={6} mx={4}>
          <Stack
            borderWidth="1px"
            borderRadius="lg"
            w={{ sm: '100%', md: '540px' }}
            height={{ sm: '476px', md: '20rem' }}
            direction={{ base: 'column', md: 'row' }}
            bg={useColorModeValue('white', 'gray.900')}
            boxShadow={'2xl'}
            padding={4}
          >
            <Flex flex={1} bg="blue.200">
              <Image objectFit="cover" boxSize="100%" src={`${Project01}`} />
            </Flex>
            <Stack
              flex={1}
              flexDirection="column"
              justifyContent="center"
              alignItems="center"
              p={1}
              pt={2}
            >
              <Heading fontSize={'2xl'} fontFamily={'body'}>
                Fitness Blender
              </Heading>
              <Text fontWeight={600} color={'gray.500'} size="sm" mb={4}>
                @cloned_project
              </Text>
              <Text
                textAlign={'center'}
                color={useColorModeValue('gray.700', 'gray.400')}
                px={3}
              >
                This a clone project of very popular websites among fitness
                enthusiasts which helps user to fit & healthy.
              </Text>
              <Stack
                align={'center'}
                justify={'center'}
                direction={'row'}
                mt={6}
              >
                <Badge
                  px={2}
                  py={1}
                  bg={useColorModeValue('gray.50', 'gray.800')}
                  fontWeight={'400'}
                >
                  #HTML5
                </Badge>
                <Badge
                  px={2}
                  py={1}
                  bg={useColorModeValue('gray.50', 'gray.800')}
                  fontWeight={'400'}
                >
                  #CSS3
                </Badge>
                <Badge
                  px={2}
                  py={1}
                  bg={useColorModeValue('gray.50', 'gray.800')}
                  fontWeight={'400'}
                >
                  #Javascript
                </Badge>
              </Stack>

              <Stack
                width={'100%'}
                mt={'2rem'}
                direction={'row'}
                padding={2}
                justifyContent={'space-between'}
                alignItems={'center'}
              >
                <Button
                  flex={1}
                  fontSize={'sm'}
                  rounded={'full'}
                  _focus={{
                    bg: 'gray.200',
                  }}
                >
                  Live!
                </Button>
                <Link
                  href={'https://github.com/sanjayrathva091/fitnessBlender'}
                  target={'_blank'}
                >
                  <Button
                    flex={1}
                    fontSize={'sm'}
                    rounded={'full'}
                    bg={'blue.400'}
                    color={'white'}
                    boxShadow={
                      '0px 1px 25px -5px rgb(66 153 225 / 48%), 0 10px 10px -5px rgb(66 153 225 / 43%)'
                    }
                    _hover={{
                      bg: 'blue.500',
                    }}
                    _focus={{
                      bg: 'blue.500',
                    }}
                  >
                    Source Code
                  </Button>
                </Link>
              </Stack>
            </Stack>
          </Stack>
        </Center>
      </SimpleGrid>
    </Container>
  );
};

export default Projects;
